import { makeExecutableSchema } from '@graphql-tools/schema';
import { withScalars } from 'apollo-link-scalars';
import { GraphQLScalarType, Kind } from 'graphql';
import { antennaDpTypeDefs } from '../code-generated/antennaDpSchemaTypeDefs.generated';
import { controlPlaneTypeDefs } from '../code-generated/controlPlaneSchemaTypeDefs.generated';
import { curatedTypeDefs } from '../code-generated/curatedSchemaTypeDefs.generated';
import { dataPlaneTypeDefs } from '../code-generated/dataPlaneSchemaTypeDefs.generated';
import { DataProductApi } from '../constants/api';

const AWSDateTime = new GraphQLScalarType({
  name: 'AWSDateTime',
  description: 'An ISO-8601 encoded UTC datetime string.',
  serialize: value => (value as Date).toISOString(),
  parseValue: value => new Date(value as string | number),
  parseLiteral: ast => (ast.kind === Kind.STRING || ast.kind === Kind.INT ? new Date(ast.value) : null),
});

const AWSJSON = new GraphQLScalarType({
  name: 'AWSJSON',
  description: 'An untyped json blob',
  serialize: value => JSON.stringify(value),
  parseValue: value => (typeof value === 'string' ? (JSON.parse(value) as unknown) : null),
  parseLiteral: ast => (ast.kind === Kind.STRING ? (JSON.parse(ast.value) as unknown) : null),
});

const Long = new GraphQLScalarType({
  name: 'Long',
  description: 'A 64-bit integer value',
  serialize: value => (value == null ? null : Number(value as number | string)),
  parseValue: value => (value == null ? null : Number(value as number | string)),
  parseLiteral: ast => (ast.kind === Kind.INT || ast.kind === Kind.STRING ? Number(ast.value) : null),
});

// Apollo's scalar links and schema-aware tools must use the same generated schemas.
export const dataProductSchemas = {
  [DataProductApi.CURATED_API]: makeExecutableSchema({
    typeDefs: curatedTypeDefs,
    resolvers: { AWSDateTime, AWSJSON },
  }),
  [DataProductApi.DATA_PLANE_API]: makeExecutableSchema({
    typeDefs: dataPlaneTypeDefs,
    resolvers: { AWSDateTime },
  }),
  [DataProductApi.CONTROL_PLANE_DATA_PRODUCT_API]: makeExecutableSchema({
    typeDefs: controlPlaneTypeDefs,
    resolvers: { AWSDateTime },
  }),
  [DataProductApi.ANTENNA_DATA_PRODUCT_API]: makeExecutableSchema({
    typeDefs: antennaDpTypeDefs,
    resolvers: { AWSJSON, Long },
  }),
} satisfies Record<DataProductApi, ReturnType<typeof makeExecutableSchema>>;

// Pre-built per-API Apollo scalar links, derived from the shared schemas above so both the
// production client (GsocApolloProvider) and the mock client (index.mock) parse scalars
// identically. Built once at module load to avoid re-parsing schemas on each render.
export const scalarsLinkForApi: Record<DataProductApi, ReturnType<typeof withScalars>> = {
  [DataProductApi.CURATED_API]: withScalars({
    schema: dataProductSchemas[DataProductApi.CURATED_API],
  }),
  [DataProductApi.DATA_PLANE_API]: withScalars({
    schema: dataProductSchemas[DataProductApi.DATA_PLANE_API],
  }),
  [DataProductApi.CONTROL_PLANE_DATA_PRODUCT_API]: withScalars({
    schema: dataProductSchemas[DataProductApi.CONTROL_PLANE_DATA_PRODUCT_API],
  }),
  [DataProductApi.ANTENNA_DATA_PRODUCT_API]: withScalars({
    schema: dataProductSchemas[DataProductApi.ANTENNA_DATA_PRODUCT_API],
  }),
};
